import { IChatRooms } from '@commenda/types';
import { EmptyStateV2 } from '../../components/empty-state/EmptyStateV2';
import { ChatRoomRow } from './components/ChatRoomRow';

type AllMessagesViewProps = {
  chatRooms: IChatRooms['chatRooms'];
  onSelectChatRoomId: (chatRoomId: string) => void;
  showBusinessEntityName: boolean;
};

export const AllMessagesView = ({
  chatRooms,
  onSelectChatRoomId,
  showBusinessEntityName,
}: AllMessagesViewProps) => {
  if (!chatRooms || chatRooms.length === 0)
    return (
      <EmptyStateV2
        className="rounded-md rounded-t-none bg-white border-none"
        title="No active chats messages"
        description="Any messages in a chat will appear here."
      />
    );

  return (
    <div className="flex flex-col divide-y divide-border-primary border-b border-border-primary">
      {chatRooms.map((chatRoom) => (
        <ChatRoomRow
          key={chatRoom.id}
          chatRoom={chatRoom}
          onSelectChatRoomId={onSelectChatRoomId}
          showBusinessEntityName={showBusinessEntityName}
        />
      ))}
    </div>
  );
};
